import { Injectable, signal } from '@angular/core'

export interface Toast {
  type: 'success' | 'info' | 'warning' | 'error'
  message: string
  classname?: string
  delay?: number
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toasts = signal<Toast[]>([])

  show(toast: Toast) {
    this.toasts.update((current) => [...current, toast])
  }

  remove(toast: Toast) {
    this.toasts.update((current) => current.filter((t) => t !== toast))
  }

  clear() {
    this.toasts.set([])
  }
}
